<template>
<div>
	 <v-dialog title="新增教室" v-model="hideShow" width="600" persistent scrollable>
		<v-card class="fc-dialog-card mg-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-cog-outline</v-icon></span><div class="mg-dialog-title"><h2>新增教室</h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭新增教室" @click="cancel"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>
			<v-card-text class="fc-dialog-body">
				<v-row dense>

					<v-col cols="12">
						<v-text-field label="教室名称" v-model="add.roomName" dense outlined color="#d9363e" aria-label="教室名称"></v-text-field>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="cancel" depressed>取消</v-btn>
				<v-btn @click="submitAdd" color="#d9363e" depressed class="fc-confirm">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
 </div>
</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"create-room",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
			},
			
		},
		data(){
			return {
				add: {
					roomName:""
				},
				hideShow:this.show,
			}
		},
		mounted() {
			console.log("create-room mounted");
		},
		methods:{
			
			submitAdd(){
				
				if (!this.add.roomName) {
					this.$noty.error('教室名称不能为空');
					return
				}
				const shopId = utils.getCurrentShopId();			
				// api
				const that = this;
				let url = `/edu/classroom/create`;
				let postData = {...this.add};
				postData.shopId = shopId;
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");						
							this.$emit("success","");			
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
				
			},
			cancel(){
				this.$emit("cancel","");
			}
		}
	}
	
</script>
<style>
</style>
<style lang="scss" scoped src="../assets/styles/management.scss"></style>
